import React, { useState, useEffect } from "react";
import OnloadPopup from "./OnloadPopup";
import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";
import banner from "./images/about-us-banner.png";
import Section1 from "./images/Section-1-img.png";
import aboutimg1 from "./images/about-img-12.png";

import aboutthumb from "./images/about-thumb-4.png";
import aboutthumb1 from "./images/about-thumb-2.png";
import aboutthumb2 from "./images/about-thumb-5.png";

import AOS from "aos";
import "aos/dist/aos.css";
AOS.init({
  disable: isMobile,
});

const photogallery = [
  require("./images/pg-h-1.png"),
  require("./images/pg-h-2.png"),
  require("./images/pg-h-3.png"),
  require("./images/pg-h-4.png"),
  require("./images/pg-h-5.png"),
  require("./images/pg-h-6.png"),
  require("./images/pg-h-7.png"),
  require("./images/pg-h-8.png"),
];

const instagallery = [
  require("./images/insta-h-1.png"),
  require("./images/insta-h-2.png"),
  require("./images/insta-h-3.png"),
  require("./images/insta-h-4.png"),
  require("./images/insta-h-5.png"),
  require("./images/insta-h-6.png"),
  require("./images/insta-h-7.png"),
  require("./images/insta-h-8.png"),
  require("./images/insta-h-7.png"),
  require("./images/insta-h-8.png"),
];

function TermsandConditions() {
  {
    /*Popup scripts start */
  }
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // Show the popup after 30 seconds
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 5000); // Change to 30000 for 30 seconds

    // Clear the timer on cleanup
    return () => clearTimeout(timer);
  }, []);

  const closePopup = () => {
    setShowPopup(false);
  };
  {
    /*Popup scripts End */
  }
  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: false, // Only animate once
      disable: () => window.innerWidth < 768, // Disable on mobile (screen width < 768px)
    });
  }, []);
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return (
    <div>
      {/* {showPopup && <OnloadPopup closePopup={closePopup} />} */}
      <div>
        <div className="Banner">
          <img src={banner} alt="" />
          <h1>Terms and Conditions</h1>
        </div>
        <div className="about-section-1-bg  ">
          <div className="wrapper">
            <div className="home-section-1-wrap">
              <div
                className="home-section-1-2 privacypolicy"
                data-aos="fade-up-left"
              >
                <p>
                  Welcome to Rostre Spaces! These Terms and Conditions ("Terms")
                  govern your use of our website www.rostrespaces.com and any
                  services provided by Rostre Spaces ("we", "our", or "us"). By
                  accessing or using our website, you agree to comply with and
                  be bound by these Terms. If you do not agree, please do not
                  use our services.
                </p>
                <h3>Use of the Website</h3>
                <p>
                  You agree to use the website only for lawful purposes and in a
                  manner that does not infringe the rights of, restrict, or
                  inhibit anyone else's use of the site. Prohibited behavior
                  includes harassing or causing distress to any person,
                  transmitting obscene or offensive content, or disrupting the
                  normal flow of dialogue within the site.
                </p>
                <h3>Services Overview</h3>
                <p>
                  Rostre Spaces provides flexible office solutions including
                  coworking spaces, private offices, and meeting rooms. The
                  availability and specifications of these services are subject
                  to change without prior notice.
                </p>
                <h3>Intellectual Property</h3>
                <p>
                  All content on this website, including text, graphics, logos,
                  images, and software, is the property of Rostre Spaces or its
                  content suppliers and is protected by applicable intellectual
                  property laws. You may not reproduce, duplicate, copy, sell,
                  resell, or exploit any portion of the website without express
                  written permission from us.
                </p>
                <h3>Booking and Payments</h3>
                <p>
                  Some of our services may require booking and payment through
                  third-party platforms or direct contact. All bookings are
                  subject to availability. Rostre Spaces reserves the right to
                  decline or cancel a booking at its discretion.
                </p>
                <h3>Cancellation and Refund Policy</h3>
                <p>
                  Cancellation policies for services such as space bookings will
                  be communicated during the booking process. Refunds, if
                  applicable, will be processed as per the cancellation terms
                  outlined at the time of booking.
                </p>
                <h3>Limitation of Liability</h3>
                <p>
                  We strive to provide accurate and updated information.
                  However, we do not warrant that the website content will be
                  error-free or uninterrupted. Rostre Spaces will not be held
                  liable for any direct, indirect, incidental, or consequential
                  damages arising out of your access or use of the website or
                  services.
                </p>
                <h3>Third-party Links</h3>
                <p>
                  Our website may contain links to third-party websites or
                  services not owned or controlled by us. Rostre Spaces has no
                  control over and assumes no responsibility for the content,
                  policies, or practices of any third-party sites.
                </p>
                <h3>Privacy</h3>
                <p>
                  Your use of our website is also governed by our Privacy
                  Policy, which outlines how we collect, use, and protect your
                  personal information. Please review it carefully.
                </p>
                <h3>Modifications to Terms</h3>
                <p>
                  We reserve the right to update or modify these Terms at any
                  time without prior notice. Your continued use of the website
                  after any such changes constitutes your acceptance of the new
                  Terms.
                </p>
                <h3>Governing Law</h3>
                <p>
                  These Terms shall be governed and construed in accordance with
                  the laws of India. Any disputes arising out of or in
                  connection with these Terms shall be subject to the exclusive
                  jurisdiction of the courts in Hyderabad, Telangana.
                </p>
                <h3>Contact Us</h3>
                <p>
                  For questions regarding these Terms and Conditions, please
                  contact us at:
                </p>

                <p>
                  Rostre Spaces
                  <br />
                  info@rostre.in
                  <br />
                  Hyderabad, Telangana, India
                </p>
                {/*                 
                <Link to="/why-choose-rostre" className="button-3" on>
                  Learn More
                </Link> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TermsandConditions;
